export abstract class CouponCodeException extends Error {
}
